import axios from 'axios';    
import { getQueryParam } from 'utils';
import { PONERA_ROUTES } from 'routes';


const redirectExcludedRoutes = [
    '/login'
  ]

try {
    const lang = getQueryParam('lang')// window.location.pathname.split('/')[1]

    if(/^([a-z]{2})-([a-z]{2})$/i.test(lang)){
        sessionStorage.setItem('__appLang', lang);
    }else if(sessionStorage.getItem('__appLang') == null){
        sessionStorage.setItem('__appLang', 'en-US');
    }

  } catch (error) {
    console.warn('Switch to default app language')
  }

export var API_URL = process.env.REACT_APP_API_URL;

export const HTTP = axios.create({
    withCredentials: true,
    baseURL: API_URL,
    headers: {
        'Accept-Language' : sessionStorage.getItem('__appLang')
    }
})

// Add a request interceptor
HTTP.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    //config.headers.Authorization = `Bearer ${your_token}`;
    // OR config.headers.common['Authorization'] = `Bearer ${your_token}`;
    //config.baseURL = '/mock/';
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

HTTP.interceptors.response.use((response) => {
    return response;
}, (error) => {
    const { config, response: { status } } = error;

    if (status === 401) {
        if (!redirectExcludedRoutes.some(r => window.location.href.indexOf(r) != -1)) {
            window.location.href = PONERA_ROUTES.LOGIN
        }
    }
    return Promise.reject(error);
}
)

window.__HTTP = HTTP

function setUserPassword(o){
    return HTTP.get('../../mock/setUserPassword.json')
}

export {

}